import { IStyle, mergeStyles } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../../../common/styles/common.styles';

export const RecordingStateIconName = 'Pause';
export const PausedStateIconName = 'Microphone';

const micWidgetHeightPx = 48;
const micWidgetWidthPx = 48;
const micWidgetContainerHeightPx = 70;
const micWidgetContainerWidthPx = 70;

const micWidgetThickBorder = '4px solid #2b579a';

export const getMicWidgetStyle = (): IStyle => {
  const style: IStyle = {
    background: '#ffffff',
    boxShadow: '0px 1.2px 3.6px 0px rgba(0, 0, 0, 0.13), 0px 6.4px 14.4px 0px rgba(0, 0, 0, 0.13)',
    height: `${micWidgetHeightPx}px`,
    width: `${micWidgetWidthPx}px`,
    borderRadius: '50%',
    cursor: 'pointer',
    padding: 0,
    boxSizing: 'unset'
  };

  return style;
};

export const getDisabledMicWidgetStyle = (): IStyle => {
  const style: IStyle = {
    opacity: 0.6
  };

  return style;
};

export const getEnabledMicWidgetStyle = (): IStyle => {
  const style: IStyle = {
    opacity: 1.0
  };

  return style;
};

export const getRecordingMicWidgetStyle = (): IStyle => {
  const style: IStyle = {
    border: micWidgetThickBorder,
    borderColor: AppLayoutSettings.getAppColorContainer().micWidgetBorderColor.value,
  };

  return style;
};

export const getPausedMicWidgetStyle = (): IStyle => {
  const style: IStyle = {
    border: '1px solid #ffffff'
  };

  return style;
};

export const getMicWidgetIconStyles = (recorderIconName: string): string => {
  // By default both the icons are not aligning in center, looks like some defect in the icon.
  // Therefore a forced set of top padding and text indentation is required to force the icons
  // in vertical and horizontal center.
  let topPaddingPx: string = '0px';
  let textIndentPx: string = '0px';
  if (recorderIconName == PausedStateIconName) {
    topPaddingPx = '5px';
    textIndentPx = '3px';
  } else if (recorderIconName == RecordingStateIconName) {
    topPaddingPx = '3px';
    textIndentPx = '1px';
  }

  return mergeStyles({
    fontSize: '30px',
    paddingTop: topPaddingPx,
    textIndent: textIndentPx
  });
};

export const getMicWidgetContainerCSSProperties = (): React.CSSProperties => {
  const CSSProperties: React.CSSProperties = {
    height: `${micWidgetContainerHeightPx}px`,
    width: `${micWidgetContainerWidthPx}px`,
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  return CSSProperties;
};
